import React, {useState} from 'react';
import {ICallDetailsResource} from "../../../../resources/ICallDetails.resource";
import FetchService from "../../../../services/api/FetchService";
import CompanyObserver from "../../../../mobx/company/CompanyObserver";
import SuccessEncodingModal from "./SuccessEncodingModal";
import ModalReAnalyzeCall from "../ModalReAnalyzeCall";
import styles from './styles.module.scss';

const AnalyzeIcon = ({color='#1E1E1E'}:any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 21.7502C11.4 21.7502 10.8 21.5252 10.275 21.0752L9.075 20.0252C8.85 19.8752 8.625 19.8002 8.4 19.7252L6.75 19.6502C5.4 19.5752 4.425 18.5252 4.275 17.1752L4.125 15.6002C4.125 15.3752 3.975 15.1502 3.825 14.9252L2.775 13.7252C1.95 12.7502 1.95 11.2502 2.775 10.2752L3.825 9.0752C3.975 8.9252 4.05 8.6252 4.125 8.4002L4.35 6.7502C4.425 5.4752 5.475 4.4252 6.75 4.3502L8.325 4.2002C8.55 4.2002 8.775 4.0502 9 3.9002L10.2 2.8502C11.175 2.0252 12.675 2.0252 13.65 2.8502L14.85 3.9002C15.075 4.0502 15.3 4.1252 15.525 4.2002L17.25 4.3502C18.6 4.4252 19.575 5.4752 19.725 6.8252L19.875 8.4002C19.875 8.6252 20.025 8.8502 20.175 9.0752L21.225 10.2752C22.05 11.2502 22.05 12.7502 21.225 13.7252L20.175 14.9252C20.025 15.0752 19.95 15.3752 19.875 15.6002L19.65 17.2502C19.575 18.6002 18.525 19.5752 17.175 19.7252L15.6 19.8752C15.375 19.8752 15.15 20.0252 14.925 20.1752L13.725 21.2252C13.2 21.5252 12.6 21.7502 12 21.7502ZM12 3.7502C11.7 3.7502 11.475 3.8252 11.25 4.0502L10.05 5.1002C9.6 5.4752 9.075 5.7002 8.55 5.7002L6.9 5.8502C6.3 5.8502 5.85 6.3002 5.85 6.9002L5.7 8.47519C5.625 9.0752 5.475 9.60019 5.1 9.97519L4.05 11.2502C3.675 11.7002 3.675 12.3002 4.05 12.7502L5.1 13.9502C5.475 14.4002 5.7 14.9252 5.7 15.4502L5.85 17.0252C5.925 17.6252 6.375 18.0752 6.9 18.0752L8.475 18.2252C9.075 18.3002 9.6 18.5252 9.975 18.8252L11.175 19.8752C11.625 20.2502 12.225 20.2502 12.675 19.8752L13.875 18.8252C14.325 18.4502 14.85 18.2252 15.375 18.2252L16.95 18.0752C17.55 18.0002 18 17.5502 18 17.0252L18.15 15.4502C18.225 14.8502 18.375 14.3252 18.75 13.9502L19.8 12.7502C20.175 12.3002 20.175 11.7002 19.8 11.2502L18.75 10.0502C18.375 9.60019 18.15 9.07519 18.15 8.55019L18 6.9752C17.925 6.3752 17.475 5.9252 16.95 5.9252L15.375 5.7752C14.775 5.7002 14.25 5.4752 13.875 5.1752L12.75 4.0502C12.525 3.8252 12.3 3.7502 12 3.7502ZM12.075 16.2752H12C11.625 16.2752 11.25 15.9002 11.25 15.5252V15.4502C11.25 15.0002 11.55 14.7002 12 14.7002H12.075C12.525 14.7002 12.825 15.0002 12.825 15.4502V15.5252C12.825 15.7502 12.75 15.9002 12.6 16.0502C12.45 16.2002 12.225 16.2752 12.075 16.2752ZM12 13.2002C11.55 13.2002 11.25 12.9002 11.25 12.4502V8.47519C11.25 8.0252 11.55 7.7252 12 7.7252C12.45 7.7252 12.75 8.0252 12.75 8.47519V12.4502C12.75 12.9002 12.45 13.2002 12 13.2002Z" fill={color}/>
        </svg>
    )
}

interface IProps {
    data: ICallDetailsResource;
    refreshCall: (data:any) => void;
}

const ReAnalyzeCall = ({data}:IProps) => {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isHideButton, setIsHideButton] = useState(false);
    const [isOpenApproveModal, setIsOpenApproveModal] = useState<boolean>(false);

    const handleClose = () => setIsOpenModal(false);

    const handleOpenApproveModal = () => setIsOpenApproveModal(true);
    const handleCloseApproveModal = () => setIsOpenApproveModal(false);

    const handleReAnalyze = async () => {
        setIsOpenModal(true);
        setIsHideButton(true);
        const companyId = CompanyObserver.getCompanyId();
        if(!companyId) return;
        try {
            const response = await FetchService.patchCallDecoding(companyId, data.uuid);
        } finally {
            handleCloseApproveModal();
        }
    };

    return (
        <>
            {isOpenApproveModal ? (
                <ModalReAnalyzeCall
                    handleClose={handleCloseApproveModal}
                    handleApply={handleReAnalyze}
                />
            ) : null}
            <div className={styles.analyze}>
                {!isHideButton ? (
                    <button
                        type={'button'}
                        className={styles.analyze__btn}
                        onClick={handleOpenApproveModal}
                    >
                        <AnalyzeIcon />
                        <span>Не розпізнало?</span>
                    </button>
                ) : null}
                {isOpenModal ? (
                    <SuccessEncodingModal
                        handleClose={handleClose}
                    />
                ) : null}
            </div>
        </>
    );
};

export default ReAnalyzeCall;
